import { ClientListFilter } from 'types/clientList';
import { ListRequest } from 'types/api/clientList';

export const transformToListRequestQuery = (props): ListRequest => {
  const SORT_DIRECTIONS = { '0': undefined, '1': 'ASC', '2': 'DESC' };

  return {
    sortDirection: SORT_DIRECTIONS[props.direction],
    limit: props.limit,
    sortAttribute: props.name,
    page: Number(props.page) || 0,
    searchSubstring: props.search,
    statuses: props.status,
  };
};

export const transformToListResponseQuery = (props): ClientListFilter => {
  const SORT_DIRECTIONS = { ASC: 1, DESC: 2 };

  const params = {
    direction: SORT_DIRECTIONS[props.sortDirection] || undefined,
    limit: props.limit,
    name: props.sortAttribute,
    page: Number(props.page) || 0,
    search: props.searchSubstring,
    status: props.statuses,
  };

  return Object.keys(params)
    .filter((k) => params[k])
    .reduce((a, k) => ({ ...a, [k]: params[k] }), {}) as ClientListFilter;
};
